var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading && !_vm.error)?_c('div',[_c('search-profile',{attrs:{"company":_vm.companyData,"user":_vm.companyUserData,"searchProfile":_vm.searchProfile,"metaData":{categories: _vm.categories, regions: _vm.regions}}})],1):(_vm.loading && !_vm.error)?_c('div',[_c('loader',{staticClass:"c-m-loader--large"})],1):_c('div',[_c('error-state')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdab7768","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/my-pages-sublayouts/MyPagesSearchProfile.vue
// module id = 1377
// module chunks = 0